<template>
  <section>
    <b-modal v-model="isModalActive" :width="640" scroll="keep">
      <div class="card" :style="{ 'background-image': `url(${backgroundUrl})` }">
        <div class="card-content">
          <div class="media">
            <div class="media-left">
            </div>
            <div class="media-content">
              <p class="title is-4">{{ timeline.eventTime }}</p>
            </div>
          </div>
          <div class="content">
            {{ timeline.report }}
          </div>
          <div class="options">
            <a v-for="(option, index) in shuffledOptions"
               :key="index"
               @click="selectOption(option)">
              <div class="option"><img :src="listStyleUrl" />{{ option }}</div>
            </a>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  name: 'SelectedOptions',
  props: {
    timeline: {
      type: Object,
      default: () => ({})
    },
    backgroundUrl: {
      type: String,
      default: ''
    },
    isCardModalActive: {
      type: Boolean,
      default: false
    },
    listStyleUrl: {
      type: String,
      default: ''
    }
  },
  emits: ['hideOptions', 'selectedOption'],
  data() {
    return {
      isModalActive: false
    };
  },
  computed: {
    /**
     * Shuffle answer options to randomize order
     * @returns {Array} Shuffled array of options including the correct answer
     */
    shuffledOptions() {
      if (!this.timeline.answer || !this.timeline.options) {
        return [];
      }
      
      const allOptions = [this.timeline.answer, ...this.timeline.options];
      return this.shuffle([...allOptions]);
    }
  },
  watch: {
    isCardModalActive: {
      handler(newValue) {
        this.isModalActive = newValue;
      },
      immediate: true
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.$emit('hideOptions');
      }
    }
  },
  methods: {
    /**
     * Handle option selection
     * @param {string} option - Selected option text
     */
    selectOption(option) {
      this.$emit('selectedOption', option);
      this.isModalActive = false;
    },

    /**
     * Fisher-Yates shuffle algorithm
     * @param {Array} array - Array to shuffle
     * @returns {Array} Shuffled array
     */
    shuffle(array) {
      let currentIndex = array.length;
      let randomIndex;

      // While there remain elements to shuffle
      while (currentIndex !== 0) {
        // Pick a remaining element
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // Swap it with the current element
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], 
          array[currentIndex]
        ];
      }

      return array;
    }
  }
};
</script>

<style scoped lang="scss">
.options {
  .option {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #4a4a4a;

    img {
      width: 40px;
    }
  }
}
</style>